var text = {
  heading: {
    fontFamily: 'heading',
    fontWeight: 'normal',
    lineHeight: 'heading'
  },
  body: {
    fontFamily: 'body',
    fontWeight: 'normal',
    lineHeight: 'body'
  }
};

export { text };
//# sourceMappingURL=text.esm.js.map
